<template>
    <div id="app">
        <AppLoader/>
    </div>
</template>

<script>
    import useQueue from '@/composables/front/queue/useQueue';
    import { uuid } from 'vue-uuid';
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        name: 'App',
        created() {
            useHead(process.env.VUE_APP_URL_TITLE)
            this._queue = useQueue({ router: this.$router, route: this.$route });
            this.$store.dispatch('SELECT_GENEROS_CDN');
        },
        beforeDestroy() {
            if (this._queue && this._queue.stop) this._queue.stop();
        },        
        components: {
            AppLoader: () => import(/* webpackPrefetch: true */ '@/AppLoader'),
        },
        mounted() {
            if(this.$route.query.api_token) {
                localStorage.removeItem('token');
                localStorage.setItem('token', this.$route.query.api_token);
            }

            if(! localStorage.getItem('uuid')) {
                localStorage.setItem('uuid', uuid.v4());
            }
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .v--modal-overlay {
        z-index: 9999 !important;
    }
</style>
